import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import { BLOCKS } from "@contentful/rich-text-types"
import { MARKS } from "@contentful/rich-text-types"
import { INLINES } from '@contentful/rich-text-types'
import { renderRichText } from "gatsby-source-contentful/rich-text"

import Container, { Row, TwoThird } from "../layout/container"
import Sidemenu from "../layout/sidebar";
import PublicRealm from "./public-realm";
import Yoo from "./yoo-capital";
import Ahmm from "./ahmm";
import Momentum from "./momentum";
import Spparc from "./spparc";
import ArrivingOnFoot from "./arriving-on-foot";
import Cycling from "./cycling";
import Tube from "./tube";

const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    margin-bottom: 0;
    text-transform: uppercase;
  }
  aside {
    display: none;
    .future {
        opacity: 0.5;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 1;
    }
    .feedback {
        opacity: 0.5;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;



const Button = styled(Link)`
    font-size: 1rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 0;
    border: 2px solid #00FFB4;
    color: #3C3C3B;
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    z-index: 3;
    position: relative;
    width: 100%;
  &:hover {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
  }
`

const AccordionContent = styled.div`
    .accordion {
        //border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        padding-top: 2rem;
    }

    .accordion__item {
        border-bottom: 2px solid ${(props) => props.theme.colors.primary};;
    }

    .accordion__button {
      color: ${(props) => props.theme.colors.primary};
      font-family: ${(props) => props.theme.fontTurmoil};
      cursor: pointer;
      padding: 1rem 0 1rem;
      text-align: left;
      border: none;
      text-transform: uppercase;
      font-size: 1.5rem;
      letter-spacing: 0.04em;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
        font-size: 1.2rem;
      }
      :focus {
        outline: 0;
      }
    }

    

    .accordion__button:after {
        content: "";
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M75,5C36.3,5,5,36.3,5,75s31.3,70,70,70s70-31.3,70-70S113.7,5,75,5z M75,102.3L46.1,57.6h57.8L75,102.3z'/%3E%3C/svg%3E");
        top: 4px;
        float: right;
        display: inline-block;
        position: relative;
    }

    .accordion__button[aria-expanded='true']::after,
    .accordion__button[aria-selected='true']::after {
        background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M75,5C36.3,5,5,36.3,5,75s31.3,70,70,70s70-31.3,70-70S113.7,5,75,5z M46.1,92.4L75,47.7l28.9,44.8L46.1,92.4 L46.1,92.4z'/%3E%3C/svg%3E");
    }

    [hidden] {
        display: none;
    }

    .accordion__panel {
        
        animation: fadein 0.35s ease-in;
    }

    /* -------------------------------------------------- */
    /* ---------------- Animation part ------------------ */
    /* -------------------------------------------------- */

    @keyframes fadein {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
`


const options: any = {
  renderMark: {
    [MARKS.CODE]: (embedded: any) => (
      <div dangerouslySetInnerHTML={{ __html: embedded }} />
    ),
  },
  renderNode: {
    "embedded-asset-block": (node) => {
      const alt = node.data.target.title["en-GB"];
      const url = node.data.target.fixed.src;
      return <img alt={alt} src={url} />;
    // console.log(node.data.target.fixed.src);
    },
    [INLINES.HYPERLINK]: (node) => {
      return <a href={node.data.uri} target="_blank" rel="noopener noreferrer">{node.content[0].value}</a>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (_node: any) => {
        const entry = _node.data.target


      },

  },
};


const AboutUs = () => {
    const data = useStaticQuery(graphql`{
        contentfulFuturePage {
            aboutUsIntroCopy {
                raw
            }
            aboutUsAccordion {
                content {
                    raw
                }
                title
            }
            aboutUsIntroCopy {
                raw
            }
        }
    }
    `)
  return (
    <Section id="about-us">
        <h2>
        About Us
        </h2>
        {renderRichText(data.contentfulFuturePage.aboutUsIntroCopy, options)}
        <AccordionContent>
            <Accordion allowZeroExpanded>
                {data.contentfulFuturePage.aboutUsAccordion.map(
                    (accordion, index) => (
                        <AccordionItem key={index}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    {accordion.title}
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                {renderRichText(accordion.content, options)}
                            </AccordionItemPanel>
                        </AccordionItem> 
                    ) 
                )}
            </Accordion>
        </AccordionContent>
    </Section>
  );
};

export default AboutUs 